var render = function render(){var _vm=this,_c=_vm._self._c;return _c('FormulateInput',_vm._b({attrs:{"validation-behavior":"live","disabled":_vm.disabled,"value":_vm.computedValue,"fullObject":_vm.fullObject},on:{"update:fullObject":function($event){return _vm.$emit('update:fullObject', $event)},"input":_vm.handleInput}},'FormulateInput',_vm.field,false))
}
var staticRenderFns = []

export { render, staticRenderFns }